import { AxiosInstance, AxiosError } from "axios"
import { makeApiErrorMessage } from "./make-api-error-message"
declare global {
	interface Window {
		sentry?: any
	}
}
export const applySentryInterceptor = (axios: AxiosInstance) => {
	axios.interceptors.response.use(
		(response) => response,
		(error: AxiosError) => {
			// Only apply Sentry interceptor on client-side
			if (typeof window !== "undefined" && error.response) {
				window?.sentry?.hub?.captureEvent({
					message: error?.response?.data?.error || makeApiErrorMessage(error),
					level: "error",
					tags: {
						apiUrl: error.config.url,
						apiMethod: error.config.method,
						status: error.response.status,
					},
					extra: {
						response: error.response,
						request: error.request,
						data: error.config.data,
					},
				})
			}
			return Promise.reject(error)
		}
	)
}
